window.initializeSwiperWhenVisible('.block__service-slider', () => {
  new Swiper('.block__service-slider', {
    loop: true,
    slidesPerView: "auto",
    paginationClickable: false,
    spaceBetween: 0,
    freeMode: false,
    autoplay: {
      delay: 0,
    },
    speed: 7000,
  });
});
